define('modules/editor/collections/custom_meta',['require','exports','module','backbone','../models/custom_meta'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      CustomMetaModel = require("../models/custom_meta");

  var Serialization = {
    toJSON: function() {
      var json = module.exports.__super__.toJSON.apply(this);
      return _.filter(json, function(model){ return model.name && model.value; });
    }
  };

  module.exports = Backbone.Collection.extend({
    model: CustomMetaModel,
    addItem: function() {
      var Model = this.model;
      this.add(new Model());
    },
    toJSON: Serialization.toJSON
  });
});

